export default __webpack_public_path__ + "static/media/Img4.6e03ff0d.jpg";